module.exports = __webpack_public_path__ + "img/one.be5786c0.png";